import React from 'react';
import { motion } from 'framer-motion';
import { Calendar, Anchor, ClipboardCheck, BarChart3, Sun, Moon, UtensilsCrossed, ArrowRight, Gift, Mail, CheckCircle2 } from 'lucide-react';
export function BonusAntiCaosSection() {
  const features = [{
    icon: <Calendar className="w-6 h-6 text-brand-gold" data-id="element-1" />,
    text: 'Plan día por día — Día 1 al Día 7 con instrucciones exactas'
  }, {
    icon: <Anchor className="w-6 h-6 text-brand-gold" data-id="element-2" />,
    text: 'Sistema de 3 Anclas diarias — funciona aunque tengas cero tiempo'
  }, {
    icon: <ClipboardCheck className="w-6 h-6 text-brand-gold" data-id="element-3" />,
    text: 'Checklist diaria para cada día de la semana'
  }, {
    icon: <BarChart3 className="w-6 h-6 text-brand-gold" data-id="element-4" />,
    text: 'Tracker imprimible — energía, sueño, antojos e hinchazón'
  }, {
    icon: <Sun className="w-6 h-6 text-brand-gold" data-id="element-5" />,
    text: 'Plantilla "Mi Rutina AM" — lista para usar en 10 minutos'
  }, {
    icon: <Moon className="w-6 h-6 text-brand-gold" data-id="element-6" />,
    text: 'Plantilla "Mi Rutina PM" — para bajar el cortisol antes de dormir'
  }, {
    icon: <UtensilsCrossed className="w-6 h-6 text-brand-gold" data-id="element-7" />,
    text: 'Plantilla "Mi Plato Base" — sin contar calorías ni obsesionarte'
  }, {
    icon: <ArrowRight className="w-6 h-6 text-brand-gold" data-id="element-8" />,
    text: 'Plan de continuidad 14 días — para no perder el ritmo después'
  }];
  const schedule = [{
    day: 'Día 1',
    result: 'Empezás con claridad — sin adivinar qué hacer'
  }, {
    day: 'Día 2',
    result: 'Menos hinchazón — más energía por la mañana'
  }, {
    day: 'Día 3',
    result: 'Mejor sueño — cortisol más bajo en la noche'
  }, {
    day: 'Día 4',
    result: 'Antojos más controlados — sin pasar hambre'
  }, {
    day: 'Día 5',
    result: 'Más energía sostenida durante el día'
  }, {
    day: 'Día 6',
    result: 'La rutina empieza a sentirse natural'
  }, {
    day: 'Día 7',
    result: 'Ves el cambio — y sabés exactamente cómo continuar'
  }];
  return <section className="py-24 px-4 bg-brand-cream relative overflow-hidden" data-id="element-9">
      {/* Decorative background elements */}
      <div className="absolute top-0 left-0 w-full h-full overflow-hidden pointer-events-none" data-id="element-10">
        <div className="absolute -top-40 -right-40 w-96 h-96 bg-brand-gold/10 rounded-full blur-3xl" data-id="element-11"></div>
        <div className="absolute bottom-20 -left-20 w-72 h-72 bg-brand-green/5 rounded-full blur-3xl" data-id="element-12"></div>
      </div>

      <div className="max-w-4xl mx-auto relative z-10" data-id="element-13">
        {/* Header Area */}
        <div className="text-center mb-16" data-id="element-14">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="inline-flex items-center gap-2 bg-brand-gold/20 text-brand-green font-bold px-4 py-2 rounded-full text-sm uppercase tracking-wider mb-6" data-id="element-15">
            <Gift className="w-4 h-4" data-id="element-16" />
            Bono Especial Incluido
          </motion.div>

          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-bold text-brand-green mb-6 leading-tight" data-id="element-17">
            El Primer Paso Que Nadie Te Había Dado
          </motion.h2>

          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-xl md:text-2xl text-brand-gray/80 max-w-2xl mx-auto font-medium" data-id="element-18">
            Para la mujer de 40+ que ya sabe que necesita cambiar — pero no sabe
            exactamente por dónde empezar hoy.
          </motion.p>
        </div>

        {/* Image and Story Content */}
        <div className="grid md:grid-cols-2 gap-12 items-center mb-20" data-id="element-19">
          <motion.div initial={{
          opacity: 0,
          x: -30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="relative" data-id="element-20">
            <div className="absolute inset-0 bg-brand-gold/20 translate-x-4 translate-y-4 rounded-2xl -z-10" data-id="element-21"></div>
            <img src="https://cdn.magicpatterns.com/uploads/iqHCo97tezJnqyAMWLBT9F/IMAGEN_-_BONO_1.png" alt="Plan Anti-Caos 7 Días (40+)" className="w-full h-auto rounded-2xl shadow-2xl border border-brand-gold/20" data-id="element-22" />
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          x: 30
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} className="space-y-6 text-lg text-brand-gray/80" data-id="element-23">
            <p data-id="element-24">Hay algo que pasa mucho después de los 40.</p>
            <p data-id="element-25">
              No es falta de ganas.
              <br data-id="element-26" />
              No es falta de información.
            </p>
            <p className="font-bold text-brand-green text-xl" data-id="element-27">
              Es que tienes demasiado de todo — y no sabes qué hacer primero.
            </p>
            <p data-id="element-28">
              Probaste mil cosas. Algunas funcionaron un poco. Otras no
              funcionaron nada.
            </p>
            <p data-id="element-29">
              Y al final del día te vas a dormir pensando:
              <br data-id="element-30" />
              <span className="italic" data-id="element-31">"Mañana empiezo de verdad."</span>
            </p>
            <p data-id="element-32">
              Pero mañana llega igual de ocupado que hoy. Y el ciclo se repite.
            </p>
            <p className="font-bold text-brand-green" data-id="element-33">
              El problema no eres tú.
            </p>
            <p data-id="element-34">
              El problema es que nadie te dio un mapa simple. Un plan que diga
              exactamente:
            </p>
            <blockquote className="border-l-4 border-brand-gold pl-4 italic bg-white/50 p-4 rounded-r-lg" data-id="element-35">
              "Hoy, haz esto. Mañana, haz esto. En 7 días, vas a notar esto."
            </blockquote>
          </motion.div>
        </div>

        {/* The Solution */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white p-8 md:p-12 rounded-3xl shadow-xl border border-brand-gold/20 mb-20" data-id="element-36">
          <div className="text-center mb-10" data-id="element-37">
            <h3 className="text-2xl md:text-3xl font-bold text-brand-green mb-6" data-id="element-38">
              Eso es exactamente lo que es el Plan Anti‑Caos 7 Días (40+).
            </h3>
            <p className="text-lg text-brand-gray/80 mb-4" data-id="element-39">
              Es el complemento perfecto de El Escudo Hormonal 40+.
            </p>
            <p className="text-lg text-brand-gray/80 mb-8" data-id="element-40">
              Mientras El Escudo Hormonal 40+ te da el sistema completo para
              recuperar tu equilibrio hormonal —{' '}
              <strong className="text-brand-green" data-id="element-41">
                Este bono te pone en acción desde el día 1.
              </strong>
            </p>
            <div className="bg-brand-cream/50 p-6 rounded-2xl inline-block" data-id="element-42">
              <p className="font-bold text-brand-green text-xl mb-2" data-id="element-43">
                Tres anclas diarias.
              </p>
              <p className="text-brand-gray/80" data-id="element-44">Mañana. Mediodía. Noche.</p>
              <p className="text-brand-gray/80 mt-2" data-id="element-45">
                Eso es todo lo que necesitas para empezar a sentir diferencia
                esta semana.
              </p>
            </div>
          </div>

          <h4 className="text-xl font-bold text-brand-green mb-6 text-center" data-id="element-46">
            Lo que incluye:
          </h4>
          <div className="grid md:grid-cols-2 gap-4 mb-12" data-id="element-47">
            {features.map((feature, idx) => <div key={idx} className="flex items-start gap-3 p-4 bg-brand-cream/30 rounded-xl" data-id="element-48">
                <div className="flex-shrink-0 mt-1" data-id="element-49">{feature.icon}</div>
                <span className="text-brand-gray/80 font-medium" data-id="element-50">
                  {feature.text}
                </span>
              </div>)}
          </div>

          <h4 className="text-xl font-bold text-brand-green mb-6 text-center" data-id="element-51">
            Lo que vas a notar en 7 días:
          </h4>
          <div className="overflow-x-auto" data-id="element-52">
            <table className="w-full text-left border-collapse" data-id="element-53">
              <thead data-id="element-54">
                <tr className="bg-brand-green text-white" data-id="element-55">
                  <th className="p-4 rounded-tl-xl font-semibold w-1/4" data-id="element-56">Día</th>
                  <th className="p-4 rounded-tr-xl font-semibold" data-id="element-57">
                    Lo que cambia
                  </th>
                </tr>
              </thead>
              <tbody data-id="element-58">
                {schedule.map((row, idx) => <tr key={idx} className="border-b border-brand-cream last:border-0 hover:bg-brand-cream/20 transition-colors" data-id="element-59">
                    <td className="p-4 font-bold text-brand-green" data-id="element-60">
                      {row.day}
                    </td>
                    <td className="p-4 text-brand-gray/80" data-id="element-61">{row.result}</td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </motion.div>

        {/* The Rule & Value */}
        <div className="grid md:grid-cols-2 gap-8" data-id="element-62">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-brand-green text-white p-8 md:p-10 rounded-3xl shadow-xl" data-id="element-63">
            <h4 className="text-2xl font-bold text-brand-gold mb-6" data-id="element-64">
              La regla más importante de este plan:
            </h4>
            <p className="text-xl font-medium mb-6" data-id="element-65">
              No perfección.
              <br data-id="element-66" />
              Consistencia.
            </p>
            <div className="space-y-4 text-white/90" data-id="element-67">
              <p data-id="element-68">Si un día solo podés hacer 1 ancla — está bien.</p>
              <p data-id="element-69">El sistema tiene una versión mínima para cada día.</p>
              <p data-id="element-70">
                Porque la vida de una mujer de 40+ no siempre es perfecta. Pero
                sí puede ser consistente.
              </p>
              <p data-id="element-71">
                Y esa consistencia es exactamente lo que tu cuerpo necesita para
                responder.
              </p>
              <div className="pt-6 mt-6 border-t border-white/20" data-id="element-72">
                <p className="font-bold italic" data-id="element-73">Esto no es "otro PDF más".</p>
                <p data-id="element-74">
                  Es el puente entre saber y hacer. Entre leer El Escudo
                  Hormonal 40+ y vivirlo desde hoy.
                </p>
              </div>
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="bg-white p-8 md:p-10 rounded-3xl shadow-xl border-2 border-brand-gold flex flex-col justify-center" data-id="element-75">
            <h4 className="text-2xl font-bold text-brand-green mb-6" data-id="element-76">
              ¿Cuánto vale esto?
            </h4>
            <p className="text-brand-gray/80 mb-4" data-id="element-77">
              El Plan Anti‑Caos 7 Días (40+) se vende por separado en{' '}
              <span className="line-through text-brand-red/80 font-bold" data-id="element-78">
                $47 USD
              </span>
              .
            </p>
            <div className="bg-brand-cream p-4 rounded-xl mb-6 text-center" data-id="element-79">
              <p className="text-lg text-brand-gray/80" data-id="element-80">
                Hoy lo recibís completamente
              </p>
              <p className="text-4xl font-black text-brand-green uppercase tracking-wider my-2" data-id="element-81">
                GRATIS
              </p>
              <p className="text-sm text-brand-gray/80" data-id="element-82">
                al adquirir El Escudo Hormonal 40+.
              </p>
            </div>

            <div className="space-y-4 mb-8" data-id="element-83">
              <h5 className="font-bold text-brand-green" data-id="element-84">
                ¿Por qué lo regalo?
              </h5>
              <p className="text-sm text-brand-gray/80" data-id="element-85">
                Porque el conocimiento sin acción no cambia nada. El Escudo
                Hormonal 40+ te da el sistema completo. Este bono te pone en
                movimiento desde el día 1.
              </p>
              <p className="text-sm font-bold text-brand-green" data-id="element-86">
                Son dos piezas del mismo rompecabezas. Y juntas — hacen toda la
                diferencia.
              </p>
            </div>

            <div className="flex items-start gap-3 bg-brand-green/5 p-4 rounded-xl" data-id="element-87">
              <Mail className="w-6 h-6 text-brand-green flex-shrink-0 mt-1" data-id="element-88" />
              <div data-id="element-89">
                <h5 className="font-bold text-brand-green text-sm mb-1" data-id="element-90">
                  ¿Cómo lo recibís?
                </h5>
                <p className="text-sm text-brand-gray/80" data-id="element-91">
                  Inmediatamente después de tu compra — En el mismo correo —
                  Llega el Plan Anti‑Caos junto con El Escudo Hormonal. Sin
                  esperar. Sin complicaciones. Hoy mismo podés empezar.
                </p>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </section>;
}